/**
 * Thème clair ou sombre.
 *
 * Le choix se réduit à un attribut `data-theme` sur la racine du document :
 * toute la palette est définie dans index.css, aucun composant n'a besoin de
 * savoir quel thème est actif.
 *
 * Trois états plutôt que deux : « système » suit le réglage du téléphone, ce
 * qui bascule seul le soir sans que le technicien ait à y penser, et reste le
 * défaut tant qu'il n'a pas tranché lui-même.
 */
const CLE = 'theme';
export const CHOIX = [
  { valeur: 'systeme', libelle: 'Système' },
  { valeur: 'clair',   libelle: 'Clair' },
  { valeur: 'sombre',  libelle: 'Sombre' },
];

function requeteSombre() {
  return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
}

export function lireTheme() {
  try {
    const v = localStorage.getItem(CLE);
    return CHOIX.some(c => c.valeur === v) ? v : 'systeme';
  } catch {
    // Navigation privée ou stockage refusé : on retombe sur le réglage système.
    return 'systeme';
  }
}

export function appliquerTheme(choix = lireTheme()) {
  const mq = requeteSombre();
  const sombre = choix === 'sombre' || (choix === 'systeme' && !!mq && mq.matches);
  document.documentElement.setAttribute('data-theme', sombre ? 'dark' : 'light');
  // La barre d'état du téléphone doit suivre, sinon elle tranche sur la page.
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', sombre ? '#0d1117' : '#185FA5');
  return sombre;
}

export function definirTheme(choix) {
  try { localStorage.setItem(CLE, choix); } catch { /* sans persistance */ }
  return appliquerTheme(choix);
}

/** Tant que le choix reste « système », on suit ses bascules en direct. */
export function suivreSysteme() {
  const mq = requeteSombre();
  if (!mq) return;
  const reagir = () => { if (lireTheme() === 'systeme') appliquerTheme('systeme'); };
  if (mq.addEventListener) mq.addEventListener('change', reagir);
  else if (mq.addListener) mq.addListener(reagir);
}
